<template>
  <div class="content">
    <div class='card'>
      <div class="cardHead">
        <div class="cardTitle"><img src="@/assets/images/index/data.png" alt=""> 数据看板</div>
        <div class="cardRight">
          <a-radio-group default-value="a" button-style="solid" size="small" v-model:value="day_type" @change="changeDay">
            <a-radio-button :value="1">
              近7天
            </a-radio-button>
            <a-radio-button :value="2">
              近30天
            </a-radio-button>
            <a-radio-button :value="3">
              月
            </a-radio-button>
          </a-radio-group>
          <div class="m-l-20 m-r-20">
           <a-month-picker @change="onchange" format="YYYY/MM">
            </a-month-picker>
          </div>
          <div v-has:IndexDataMenuSet='()=>{visible =true}' class="s_flex_ali">
            <span>不包含当天数据</span>
            <img src="@/assets/images/index/add_icon.png" alt="" class="m-l-20 m-r-10 m-b-3">
            <a-button type="link" style="padding-left:0">
              设置
            </a-button>
          </div>
        </div>
        <div class="line"></div>
      </div>
      <ul class='dataPanel'>
        <li v-for="v in dataPanelList" :key="v.id">
          <div class="panelContent " :class="id==v.id?'active':''" @click="changeActive(v)">
            <div class="icon">
              <img :src="info.picdomain+v.icon_url" alt="">
            </div>
            <div>
              <div class='data'>
                <div>{{v.total}}</div>
                <img src="@/assets/images/index/web-icon-@2x.png" alt="" v-if="v.yesterday_total>0">
                <div class='up' v-if="v.yesterday_total>0" >{{v.yesterday_total}}</div>
              </div>
              <div class='name'>{{v.name}}</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
   <div class='card'>
        <indexEcharts :panel="panel" :echartsData="echartsData" />
    </div>
    <!-- <div class='card'>
      <div class="cardHead">
        <div class="cardTitle"><img src="@/assets/images/index/fenlei@2x.png" alt="">常用功能</div>
        <div class="cardRight">
          <img src="@/assets/images/index/add_icon.png" alt="" class="m-l-20 m-r-10">
          <a-button type="link" style="padding-left:0">
            设置
          </a-button>
        </div>
      </div>
      <div class='untilPanel '>
        <div class="dataPanel-until dataPanel-item"><img src="@/assets/images/index/order@2x.png" alt=""> <span>订单管理</span></div>
        <div class="dataPanel-until  dataPanel-item"><img src="@/assets/images/index/qian1@2x.png" alt=""> <span>购物券</span></div>
        <div class="dataPanel-until  dataPanel-item"><img src="@/assets/images/index/ly_huiyuanka@2x.png" alt=""> <span>会员</span></div>
        <div class="dataPanel-until  dataPanel-item"><img src="@/assets/images/index/baoyou@2x.png" alt=""> <span>包邮卡</span></div>
        <div class="dataPanel-until  dataPanel-item"><img src="@/assets/images/index/jifen-5@2x.png" alt=""> <span>积分</span></div>
      </div>
    </div> -->
  </div>
  <a-modal  :keyboard="false" :width='1300' v-model:visible="visible" :bodyStyle='{height:"700px",overflowY: "auto"}' :footer="null" destroyOnClose>
    <div class="m-b-25">
      <div class="s_flex_bina_c">
        <!-- ({{list.length}}/12) -->
        <p class="s_c333 fz-16 s_font_b">我的数据看板</p>
      </div>
      <a-divider />
      <a-row :gutter="20">
        <a-col v-for='item in dataPanelList' :key='item' :span="3">
          <div class="s_bf58 bor-rad-10 p-b-20 m-b-20 s_po_re">
            <CloseCircleFilled class="fz-18 s_shou" @click='delItem(item)' style="position: absolute;top: 5px;right: 5px;color:#D8D8D8" />
            <img class="width-120 height-120 s_dis_b s_mauto" :src="info.picdomain+item.icon_url" alt="">
            <p class="s_c999 text-ac">{{item.name}}</p>
          </div>
        </a-col>
      </a-row>
    </div>
    <div class="m-b-25" v-for="(v,k) in dataPanelAllList" :key="k">
      <div class="s_flex_bian_c">
        <p class="s_c333 fz-16 s_font_b">{{k}}</p>
      </div>
      <a-divider />
      <a-row :gutter="20">
        <a-col v-for='item in v' :key='item' :span="3">
          <div class="s_bf58 bor-rad-10 p-b-20 m-b-20 s_po_re">
            <PlusCircleFilled class="fz-18 s_shou" @click='addItem(item)' style="position: absolute;top: 5px;right: 5px;color:#D8D8D8" v-if="!dataPanelList.find(v=>v.id===item.id)" />
            <img class="width-120 height-120 s_dis_b s_mauto" :src="info.picdomain+item.icon_url" alt="">
            <p class="s_c999 text-ac">{{item.name}}</p>
          </div>
        </a-col>
      </a-row>
    </div>
    <!-- <div class="s_flex_center">
      <a-button class="width-100 m-r-25" type="primary" @click="visible=!visible">确定</a-button>
      <a-button class="width-100" type="primary" ghost @click="visible=!visible">取消</a-button>
    </div> -->
  </a-modal>
</template>
<script>
import { PlusCircleFilled, CloseCircleFilled } from "@ant-design/icons-vue";
import { reactive, toRefs, onMounted } from "vue";
import { getIndex, getIndexList,setIndexList } from "@/api/index";
import store from "@/store";
import { message } from 'ant-design-vue';
export default {
  name: "Home",
  components: { PlusCircleFilled, CloseCircleFilled },
  setup() {
    const state = reactive({
      visible: false,
      list: [{}, {}, {}, {}, {}, {}, {}, {}, {}],
      dataPanelList: [], //
      dataPanelAllList: [], //
      lists: [{}, {}, {}],
      day_type: 1,
      id:"",
      time:'',
      active: "",
      disabledDate: null,
      disabledRangeTime: null,
      info: store.state.user.info,
      panel:{},
      echartsData:{}
    });
    const getInit = async function () {
        let result = await getIndex({ day_type: state.day_type,time:state.time,id:state.id })
        .then((res) => res.data)
        .catch((error) => error);
      state.dataPanelList = result.data.lists;
      state.id= state.dataPanelList[0].id
      state.panel=state.dataPanelList[0]
      state.echartsData=result.data.data
      let res = await getIndexList()
        .then((res) => res.data)
        .catch((error) => error);
      state.dataPanelAllList = res.data.lists;
    };
    const  getChartsLine= async function(){
        let result = await getIndex({ day_type: state.day_type,time:state.time,id:state.id })
        .then((res) => res.data)
        .catch((error) => error);
      state.dataPanelList = result.data.lists;
      state.echartsData=result.data.data
    }
    const changeActive = function (data) {
      state.id=data.id
      state.panel=data
      getChartsLine()
    };
    const changeDay=function(){
      if(state.day_type!=3){
         state.time=''
      }else{
      var d=new Date(new Date().getTime())
      var y=d.getFullYear()
      var m=d.getMonth() + 1
      if(m<10){
        m='0'+m
      }
      state.time=y + '-' + (m)
      }
     getChartsLine()
    }
    // 选择月
    const onchange=function(e){
      var d=new Date(new Date(e).getTime())
      var y=d.getFullYear()
      var m=d.getMonth() + 1
      if(m<10){
        m='0'+m
      }
      state.time=y + '-' + (m)
     getChartsLine()

    }
    const addItem = function (data) {
      if(state.dataPanelList.length==8){
        message.error('最多添加8条')
        return
      }
      var base=[{
            ...state.dataPanelList,
            data
      }]
      var list=state.dataPanelList
      state.dataPanelList=[data,...list]
      setIndexList({values:JSON.stringify(state.dataPanelList)})
    };
    const delItem = function (data) {
      var index=-1
        state.dataPanelList.forEach((element,key) => {
              if(element.id==data.id){
                  index=key
              }
        });
        var delData=state.dataPanelList[index]
        state.dataPanelList.splice(index,1)
        if(delData.id==state.id){
          state.id=state.dataPanelList[0]
           getChartsLine()
        }
      setIndexList({values:JSON.stringify(state.dataPanelList)})
    };
    onMounted(() => {
      getInit();
    });
    return {
      changeActive,
      ...toRefs(state),
      delItem,
      addItem,
      onchange,
      changeDay
    };
  },
};
</script>
<style lang="less" scoped>
.content {
  background-color: #f7f9f8;
}
.card {
  background-color: #fff;
  margin-bottom: 30px;
  &:last-child {
    margin-bottom: 0;
  }
  .cardHead {
    height: ~`vh(90) `;
    display: flex;
    justify-content: space-between;
    padding: ~`vh(30) ` ~`vw(50) `;
    align-items: center;
    position: relative;
    .line {
      position: absolute;
      width: calc(100% - 70px);
      bottom: 0;
      height: 1px;
      background-color: #f5f5f5;
    }
    .cardTitle {
      font-size: 14px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      color: #333333;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      img {
        width: 18px;
        height: 18px;
        margin-right: 5px;
      }
    }
    .cardRight {
      font-weight: 400;
      color: #8e8e8e;
      display: flex;
      align-items: center;
      img {
        width: 20px;
        margin-left: 10px;
      }
    }
  }
  .dataPanel {
    display: flex;
    flex-wrap: wrap;
    li {
      width: 25%;
      padding: 20px;
      cursor: pointer;
      .panelContent {
        display: flex;
        align-items: center;
        margin-bottom: ~`vh(20) `;
        border-radius: 10px;
        transition: all .3s;
        border: 1px solid transparent;
        position: relative;
        &:hover{
        box-shadow: 0px 0px 22px 0px #dbe7f3;
        }
        >div:nth-child(2){
          position: relative;
          left: -10px;
        }
      }
      .active {
        border: 1px solid #dbe7f3;
        box-shadow: 0px 0px 22px 0px #dbe7f3;
      }
      .icon {
        border-radius: 50%;
        margin-right: ~`vw(15) `;
        img {
          width: ~`vw(130) `;
          background-color: #fff;
          border-radius: 50%;
        }
      }
      .data {
        display: flex;
        font-size: 20px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 400;
        color: #333333;
        align-items: center;
        img {
          margin-left: 8px;
          width: 9px;
          margin-bottom: 5px;
        }
        .up {
          margin-left: 2px;
          font-size: 14px;
          color: #e30000;
        }
      }
      .name {
        font-size: 14px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #8e8e8e;
        line-height: 21px;
      }
    }
  }
  .untilPanel {
    display: flex;
    padding-left: ~`vw(30) `;
    margin-top: 20px;
    padding-bottom: 30px;
    .dataPanel-until {
      width: 16.6%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 65px;
      img {
        width: 40px;
        margin-bottom: 10px;
      }
    }
  }
}
</style>